import { render, staticRenderFns } from "./ChipStatus.vue?vue&type=template&id=32fbec12"
import script from "./ChipStatus.vue?vue&type=script&lang=js"
export * from "./ChipStatus.vue?vue&type=script&lang=js"
import style0 from "./ChipStatus.vue?vue&type=style&index=0&id=32fbec12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports